import React, { useContext, useEffect, useRef, useState } from 'react';
import { PlusOutlined, CloseCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Input, Popconfirm, Row, Select, Space, Table, Typography } from 'antd';
import ProductData from "../../../../config/data/casaProducts.json"
import { useForm } from 'antd/es/form/Form';
const EditableContext = React.createContext(null);

const { Text, Title, Paragraph } = Typography;

// const EditableRow = ({ index, ...props }) => {
//     const [form] = Form.useForm();
//     return (
//         <Form form={form} component={false}>
//             <EditableContext.Provider value={form}>
//                 <tr {...props} />
//             </EditableContext.Provider>
//         </Form>
//     );
// };



// const EditableCell = ({
//     title,
//     editable,
//     children,
//     dataIndex,
//     record,
//     handleSave,
//     ...restProps
// }) => {
//     const [editing, setEditing] = useState(false);
//     const inputRef = useRef(null);
//     const form = useContext(EditableContext);
//     useEffect(() => {
//         if (editing) {
//             inputRef.current.focus();
//         }
//     }, [editing]);

//     const toggleEdit = () => {
//         setEditing(!editing);
//         form.setFieldsValue({
//             [dataIndex]: record[dataIndex],
//         });
//     };
//     const save = async () => {
//         try {
//             const values = await form.validateFields();
//             toggleEdit();
//             handleSave({
//                 ...record,
//                 ...values,
//             });
//         } catch (errInfo) {
//             console.log('Save failed:', errInfo);
//         }
//     };
//     let childNode = children;
//     if (editable) {
//         childNode = editing ? (
//             <Form.Item
//                 style={{
//                     margin: 0,
//                 }}
//                 name={dataIndex}
//                 rules={[
//                     {
//                         required: true,
//                         message: `${title} is required.`,
//                     },
//                 ]}
//             >
//                 <Input ref={inputRef} onPressEnter={save} onBlur={save} />
//             </Form.Item>
//         ) : (
//             <div
//                 className="editable-cell-value-wrap"
//                 style={{
//                     paddingRight: 24,
//                 }}
//                 onClick={toggleEdit}
//             >
//                 {children}
//             </div>
//         );
//     }
//     return <td {...restProps}>{childNode}</td>;
// };



const FormDataTable = ({disabled, setDisabled, formData, form}) => {
    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(2);
  






    const handleDelete = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
    };

    const defaultColumns = [
        {
            title: "Name",
            dataIndex: "name",
            editable: true,
            render: () => <Form.Item name={"name"}>
                <Input />
            </Form.Item>
        },
        {
            title: "Type",
            dataIndex: "type",
            render: () => <Form.Item name={"type"}>
                <Select
                    // defaultValue={ProductData[0]}
                    options={[
                        { value: "string", label: "String" },
                        { value: "number", label: "Number" },
                        { value: "decimal", label: "Decimal" },
                        { value: "boolean", label: "Boolean" },
                        { value: "date", label: "Date" },
                        { value: "dateTime", label: "Date & Time" },
                        { value: "text", label: "Text" },
                        { value: "dropDown", label: "Drop-down" },
                    ]}
                />
            </Form.Item>
        },
        {
            title: "Mandatory",
            dataIndex: "mandatory",
            render: () => <Form.Item name={"mandatory"}>
                <Checkbox />
            </Form.Item>
        },
        {
            title: "Length",
            dataIndex: "length",
            render: () => <Form.Item name={"length"}>
                <Input />
            </Form.Item>
        },
        {
            title: "Code",
            dataIndex: "code",
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => handleDelete(record.key)}
                        okText="OK"
                        cancelText="Cancel"
                        okButtonProps={{
                            style: {
                                backgroundColor: '#15CCAE',
                                color: 'white',
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                            }
                        }}
                        cancelButtonProps={{
                            style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                            }
                        }}
                    >
                        <CloseOutlined style={{ color: "#92428B", fontSize: "15px", fontWeight: "bolder" }} />
                    </Popconfirm>
                ) : null,
        },
    ];

    const handleAdd = async () => {
        try {
            const formValues = await form.validateFields();

            if (formValues === null) {
                return;
            } else {
                setDisabled(false);
                const newData = {
                    key: count,
                    name: "",
                    type: "",
                    mandatory: "",
                    length: "",
                    code: "",
                    actions: ""
                };
                setDataSource([...dataSource, newData]);
                setCount(count + 1);
            }
        } catch (errorInfo) {
            console.error('Form validation error:', errorInfo);
        }
    };


    const handleSave = (row) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setDataSource(newData);
    };

    // const components = {
    //     body: {
    //         row: EditableRow,
    //         cell: EditableCell,
    //     },
    // };

    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    return (
        <div>
            {/* <Form onFinish={onFinishForm} layout="vertical" form={form} initialValues={formData}> */}
                <Space
                    style={{
                        display: 'flex',
                        marginBottom: 8,
                    }}
                    align="baseline"
                >
                    <Text strong style={{ fontSize: "15px", margin: "5px" }}>Add columns</Text>
                    <Form.Item
                        name={"colName"}
                        rules={[
                            {
                                required: true,
                                message: "Column name required",
                            },
                        ]}
                    >
                        <Input style={{ width: "30vh" }} placeholder="Column Name" />
                    </Form.Item>
                    <Form.Item
                        name={"colType"}
                        rules={[
                            {
                                required: true,
                                message: 'Type required',
                            },
                        ]}
                    >
                        <Select
                            placeholder={"Select Column type"}
                            style={{ width: "30vh" }}
                            showSearch
                            options={[
                                { value: "string", label: "String" },
                                { value: "number", label: "Number" },
                                { value: "decimal", label: "Decimal" },
                                { value: "boolean", label: "Boolean" },
                                { value: "date", label: "Date" },
                                { value: "dateTime", label: "Date & Time" },
                                { value: "text", label: "Text" },
                                { value: "dropDown", label: "Drop-down" },
                            ]} />
                    </Form.Item>
                    <Button
                        onClick={handleAdd}
                        type="primary"
                        icon={<PlusOutlined />}
                        style={{ backgroundColor: "#15CCAE", color: "white", width: "15vh" }}
                    > Add
                    </Button>
                </Space>
            {/* </Form> */}
            <div hidden={disabled}>
                <Table
                    // components={components}
                    rowClassName={() => 'editable-row'}
                    // bordered
                    dataSource={dataSource}
                    columns={columns}
                />
            </div>
        </div>
    );
};
export default FormDataTable;


